import { connect } from 'react-redux'
import { fetchSFM, getPending, destroy as destroyFetchInstance } from 'loankeeper-common/helpers/SimpleFetchManager'

import { destroy as destroyLKGridInstance } from '../LKGrid'
import { actions as LKModalActions } from '../LKModal'
import { translateLKMessage } from './translate'

const FETCHER_NAME = 'AccrualsHistoryModal'

const mapStateToProps = (state) => ({
  loading: getPending(FETCHER_NAME)(state),
})

const mapDispatchToProps = (dispatch, { APICall, params }) => ({
  getHistory: (callback) => {
    dispatch(
      fetchSFM({
        instanceName: FETCHER_NAME,
        callApi: APICall,
        callApiArgs: [params],
        resolve: ({ Data }) => {
          callback(Data)
        },
        reject: (error) => {
          dispatch(LKModalActions.openInfo(translateLKMessage(error.Error.Message || error.Error.Text)))
        },
      }),
    )
  },

  handleModalClose: () => {
    dispatch(destroyFetchInstance(FETCHER_NAME))
    dispatch(destroyLKGridInstance('HISTORY_GRID'))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)
